export const buildLabProjects = [
  {
    name: "Database Explorer MCP",
    repository: "database-explorer-mcp",
    description:
      "An MCP server for exploring PostgreSQL, MySQL, SQLite, and MongoDB with natural-language requests.",
    language: "TypeScript",
    signal: "AI + data infrastructure",
    zh: {
      description: "基于 MCP 协议的多数据库智能探索服务，支持使用自然语言即时查询 PostgreSQL、MySQL、SQLite 与 MongoDB。",
      signal: "AI + 数据基础设施",
    },
    vi: {
      description: "Máy chủ MCP giúp khám phá PostgreSQL, MySQL, SQLite và MongoDB bằng các yêu cầu ngôn ngữ tự nhiên.",
      signal: "AI + hạ tầng dữ liệu"
    },
  },
  {
    name: "Data Analyst Pro",
    repository: "data_analyst_pro",
    description:
      "A Python toolkit for automated exploration, visualization, and natural-language analysis across files and SQL databases.",
    language: "Python",
    signal: "Data product",
    zh: {
      description: "面向本地文件与 SQL 数据库的 Python 自动化数据探索、交互式可视化与自然语言分析工具集。",
      signal: "数据中台产品",
    },
    vi: {
      description: "Bộ công cụ Python giúp tự động khám phá, trực quan hóa và phân tích bằng ngôn ngữ tự nhiên trên các tệp dữ liệu và cơ sở dữ liệu SQL.",
      signal: "Sản phẩm dữ liệu"
    },
  },
  {
    name: "MiMoHub",
    repository: "mimohub",
    description:
      "A Streamlit product for analysing Excel and CSV data with Xiaomi MiMo and conversational follow-up questions.",
    language: "Python",
    signal: "AI-native workflow",
    zh: {
      description: "基于 Streamlit 构建的智能数据分析应用，集成小米 MiMo 大模型实现 Excel/CSV 数据多轮对话深度挖掘。",
      signal: "AI 原生工作流",
    },
    vi: {
      description: "Sản phẩm xây dựng bằng Streamlit để phân tích dữ liệu Excel và CSV với Xiaomi MiMo, hỗ trợ đặt câu hỏi tiếp nối theo dạng hội thoại.",
      signal: "Quy trình AI-native"
    },
  },
  {
    name: "AI Slides",
    repository: "ai-slides",
    description:
      "A lightweight web application that turns a plain-language brief into a structured presentation.",
    language: "HTML",
    signal: "Solo product build",
    zh: {
      description: "轻量级 Web 工具，可将自然语言需求大纲毫秒级转化为排版优雅、结构清晰的演示幻灯片。",
      signal: "独立产品研发",
    },
    vi: {
      description: "Ứng dụng web gọn nhẹ biến một bản mô tả bằng ngôn ngữ thông thường thành bài thuyết trình có cấu trúc.",
      signal: "Sản phẩm tự phát triển"
    },
  },
  {
    name: "PRD Generator Skill",
    repository: "prd_generator_skill",
    description:
      "A product workflow that converts Feishu business requirements into structured, implementation-ready PRDs.",
    language: "Agent skill",
    signal: "Product operations",
    zh: {
      description: "高效的 Agent 产品工作流，可将飞书上的零碎业务诉求直接解析并提炼为符合工程落地标准的系统级 PRD 规范文档。",
      signal: "产研敏捷流程赋能",
    },
    vi: {
      description: "Quy trình sản phẩm chuyển đổi yêu cầu nghiệp vụ trên Feishu thành tài liệu PRD có cấu trúc, sẵn sàng để triển khai.",
      signal: "Vận hành sản phẩm"
    },
  },
  {
    name: "API Documentation Generator",
    repository: "api-doc-generator",
    description:
      "A Claude Code plugin that keeps API documentation aligned with a changing codebase.",
    language: "JavaScript",
    signal: "Developer experience",
    zh: {
      description: "Claude Code 插件，随着代码库持续迭代与版本更替，自动保持 API 接口文档与底层代码实时精准对齐。",
      signal: "开发者体验工程",
    },
    vi: {
      description: "Plugin Claude Code giúp tài liệu API luôn đồng bộ với mã nguồn liên tục thay đổi.",
      signal: "Trải nghiệm nhà phát triển"
    },
  },
];

export const getBuildLabProjects = (lang = 'en') => {
  return buildLabProjects.map(project => {
    const localized = lang !== 'en' ? project[lang] : null;
    if (localized) {
      return {
        ...project,
        description: localized.description || project.description,
        signal: localized.signal || project.signal,
      };
    }
    return project;
  });
};

export const getBuildLabUrl = (repository) =>
  `https://github.com/nandanosql/${repository}`;
